import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import LeasingNavigationIcon from 'Icons/NavigationItem/Leasing';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements/LoadingContent';

const LazyLeftHeaderComponent = React.lazy(() => import('./Application/LeftHeaderComponent'));
const LazyApplicationPage = React.lazy(() => import('./Application/Pages/Page'));
const LazyMainPage = React.lazy(() => import('./Main/Pages/Page'));

const leasingConfiguration: FeatureConfiguration = {
    name: 'Lease Application',
    application: {
        url: '/app/lease-application',
        PageRoot: (
            <React.Suspense fallback={<LoadingContent />}>
                <LazyApplicationPage />
            </React.Suspense>
        ),
        LeftHeaderComponent: (
            <React.Suspense fallback={<LoadingContent />}>
                <LazyLeftHeaderComponent />
            </React.Suspense>
        ),
        isGloballyAccessible: true,
        permissions: [],
    },
    navigationItem: {
        route: {
            text: 'common:sidebar.featureLeasingTitle',
            url: '/leasing',
            Icon: LeasingNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyMainPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ViewLeaseApplication],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (settings && settings.leasing) {
            return settings.leasing.visible;
        }

        return false;
    },
};

export default leasingConfiguration;
